import logo from './logo.svg';
import './App.css';
import Nav from './components/nav';

function App() {
  return (
    <div>
      <Nav />
    </div>
  );
}

export default App;
